import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { useState } from "react";
import OnboardingExpertDataService from "../../services/OnboardingExpert";
export const CreateOnboardingExpert = ({ isOpen, onClose, func }: any) => {

  const [email, setEmail] = useState("");
  
  const createExpert = () => {
    OnboardingExpertDataService.createOnboardingExpert(email).then(
      (res: any) => {
        onClose();
        setEmail("");
        func(true);
      }
    );
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add onboarding expert email</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl>
              <FormLabel>Enter expert email</FormLabel>
              <Input
                value={email}
                type="text"
                onChange={(e) => setEmail(e.target.value)}
              />
            </FormControl>
          </ModalBody>
          <ModalFooter>
          <Button
            bgColor="#327171"
            color={"white"}
            mr={3}
            onClick={() => {
              createExpert();
            }}
          >
            Submit
          </Button>
          <Button bgColor="red" color={"white"} onClick={onClose}>
            Cancel
          </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
